import React from "react";
import { styled, css } from "styled-components";
import TransparentIconButton from "../TransparentIconButton";
import { Close } from "../../icons";
import Colors from "../../styles/Colors";
import rem from "../../utils/rem";
const StyledAlertBanner = styled.div `
  padding: ${rem(16)} ${rem(20)};
  border-radius: 5px;
  background-color: ${Colors.GRAY_LIGHT};
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.24);
  color: ${Colors.BLACK};
  font-size: ${rem(16)};
  line-height: ${rem(24)};
  font-weight: normal;
  width: 100%;
  position: relative;

  button {
    position: absolute;
    top: ${rem(2)};
    right: ${rem(4)};
  }

  ${({ type }) => type === "info" &&
    css `
      button {
        color: ${Colors.BLACK};
      }
    `};
  ${({ type }) => type === "error" &&
    css `
      background-color: ${Colors.ALERT_ERROR_LIGHT};
      color: ${Colors.ALERT_ERROR};

      button {
        color: ${Colors.ALERT_ERROR};
      }
    `};

  ${({ type }) => type === "success" &&
    css `
      background-color: ${Colors.ALERT_SUCCESS_LIGHT};
      color: ${Colors.ALERT_SUCCESS};
      button {
        color: ${Colors.ALERT_SUCCESS};
      }
    `};

  ${({ length }) => length === "fixed" &&
    css `
      max-width: ${rem(324)};
    `};

  ${({ position, absolute, transformToParent }) => position &&
    css `
      position: ${absolute ? "absolute" : "fixed"};

      ${position === "top-right" &&
        css `
        top: 20px;
        right: 20px;
        ${transformToParent &&
            css `
          transform: translateY(calc(-100% - 4px));
        `}
      `}

      ${position === "top-left" &&
        css `
        top: 20px;
        left: 20px;
        ${transformToParent &&
            css `
          transform: translateY(calc(-100% - 4px));
        `}
      `}

            ${position === "bottom-left" &&
        css `
        bottom: 20px;
        left: 20px;
        ${transformToParent &&
            css `
          transform: translateY(calc(100% + 4px));
        `}
      `}

            ${position === "bottom-right" &&
        css `
        bottom: 20px;
        right: 20px;
        ${transformToParent &&
            css `
          transform: translateY(calc(100% + 4px));
        `}
      `}
    `}

  p {
    margin: 0;
    max-width: 90%;
  }
`;
const AlertHeader = styled.span `
  font-weight: 500;
`;
export const AlertBanner = React.forwardRef(({ header, onClose, closeBtnTitle, children, position, absolute, transformToParent, length, type = "info", }, ref) => (React.createElement(StyledAlertBanner, { ref: ref, transformToParent: transformToParent, position: position, length: length, absolute: absolute, type: type },
    React.createElement("p", null,
        header && React.createElement(AlertHeader, null,
            header,
            " "),
        children),
    onClose && (React.createElement(TransparentIconButton, { size: 14, type: "button", onClick: onClose, icon: Close, title: closeBtnTitle })))));
export default AlertBanner;
//# sourceMappingURL=AlertBanner.js.map